import { howItWorks } from "../lib/content";

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="section-pad bg-ink-soft">
      <div className="container-page">
        <div className="max-w-2xl">
          <span className="eyebrow">{howItWorks.eyebrow}</span>
          <h2 className="h-section mt-4">{howItWorks.heading}</h2>
          <p className="lead">{howItWorks.subheading}</p>
        </div>

        <ol className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-4">
          {howItWorks.steps.map((step, index) => (
            <li key={step.step} className="relative">
              <div className="card h-full p-6 shadow-card">
                <div className="flex items-center gap-3">
                  <span className="inline-flex h-9 w-9 items-center justify-center rounded-lg bg-brand-500 text-sm font-bold text-white">
                    {step.step}
                  </span>
                  {index < howItWorks.steps.length - 1 && (
                    <span className="hidden h-px flex-1 bg-ink-line lg:block" aria-hidden="true" />
                  )}
                </div>
                <h3 className="mt-5 text-base font-semibold text-ink">{step.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-ink-muted">{step.body}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
